export const POPULAR_PHONE_COUNTRIES = [
  // Europa
  { phone_Code: '33', country_Name: 'France', iso3: 'FRA' },
  { phone_Code: '49', country_Name: 'Allemagne', iso3: 'DEU' },
  { phone_Code: '44', country_Name: 'Royaume-Uni', iso3: 'GBR' },
  { phone_Code: '34', country_Name: 'Espagne', iso3: 'ESP' },
  { phone_Code: '39', country_Name: 'Italie', iso3: 'ITA' },
  { phone_Code: '351', country_Name: 'Portugal', iso3: 'PRT' },
  { phone_Code: '32', country_Name: 'Belgique', iso3: 'BEL' },
  { phone_Code: '31', country_Name: 'Pays-Bas', iso3: 'NLD' },
  { phone_Code: '41', country_Name: 'Suisse', iso3: 'CHE' },
  { phone_Code: '43', country_Name: 'Autriche', iso3: 'AUT' },
  { phone_Code: '353', country_Name: 'Irlande', iso3: 'IRL' },
  { phone_Code: '48', country_Name: 'Pologne', iso3: 'POL' },
  { phone_Code: '46', country_Name: 'Suède', iso3: 'SWE' },
  { phone_Code: '47', country_Name: 'Norvège', iso3: 'NOR' },
  { phone_Code: '45', country_Name: 'Danemark', iso3: 'DNK' },
  { phone_Code: '358', country_Name: 'Finlande', iso3: 'FIN' },
  { phone_Code: '30', country_Name: 'Grèce', iso3: 'GRC' },
  { phone_Code: '420', country_Name: 'République tchèque', iso3: 'CZE' },
  { phone_Code: '36', country_Name: 'Hongrie', iso3: 'HUN' },
  { phone_Code: '40', country_Name: 'Roumanie', iso3: 'ROU' },
  { phone_Code: '380', country_Name: 'Ukraine', iso3: 'UKR' },
  { phone_Code: '352', country_Name: 'Luxembourg', iso3: 'LUX' },
  { phone_Code: '354', country_Name: 'Islande', iso3: 'ISL' },
  // Resto do mundo
  { phone_Code: '1', country_Name: 'États-Unis / Canada', iso3: 'USA' },
  { phone_Code: '55', country_Name: 'Brésil', iso3: 'BRA' },
  { phone_Code: '52', country_Name: 'Mexique', iso3: 'MEX' },
  { phone_Code: '54', country_Name: 'Argentine', iso3: 'ARG' },
  { phone_Code: '86', country_Name: 'Chine', iso3: 'CHN' },
  { phone_Code: '81', country_Name: 'Japon', iso3: 'JPN' },
  { phone_Code: '91', country_Name: 'Inde', iso3: 'IND' },
  { phone_Code: '61', country_Name: 'Australie', iso3: 'AUS' },
  { phone_Code: '27', country_Name: 'Afrique du Sud', iso3: 'ZAF' },
  { phone_Code: '971', country_Name: 'Émirats arabes unis', iso3: 'ARE' },
  { phone_Code: '90', country_Name: 'Turquie', iso3: 'TUR' },
  { phone_Code: '7', country_Name: 'Russie', iso3: 'RUS' },
  { phone_Code: '82', country_Name: 'Corée du Sud', iso3: 'KOR' },
  { phone_Code: '212', country_Name: 'Maroc', iso3: 'MAR' },
  { phone_Code: '213', country_Name: 'Algérie', iso3: 'DZA' },
  { phone_Code: '216', country_Name: 'Tunisie', iso3: 'TUN' },
]

export function getCountryIso3(country = {}) {
  return String(country.iso3 || country.country_Code3 || country.country_Code || '').toUpperCase()
}

export function normalizeCountryForDdi(country = {}) {
  const phoneCode = String(country.phone_Code || '').replace(/\D/g, '')
  if (!phoneCode) return null

  return {
    ...country,
    iso3: getCountryIso3(country),
    phone_Code: phoneCode,
    country_Name:
      country.country_Name || country.country_Name_En || country.country_Name_Pt || phoneCode,
  }
}

export function getDdiCountriesFromApi(apiCountries = [], preferredIso3 = '') {
  const normalizedIso3 = String(preferredIso3 || '').toUpperCase()
  const seenCodes = new Set()
  const countries = []

  ;(apiCountries || []).forEach(country => {
    const normalized = normalizeCountryForDdi(country)
    if (!normalized || seenCodes.has(normalized.phone_Code)) return
    seenCodes.add(normalized.phone_Code)
    countries.push(normalized)
  })

  countries.sort((a, b) => a.country_Name.localeCompare(b.country_Name, 'fr'))

  if (normalizedIso3) {
    const preferredIndex = countries.findIndex(country => getCountryIso3(country) === normalizedIso3)
    if (preferredIndex > 0) {
      const [preferredCountry] = countries.splice(preferredIndex, 1)
      countries.unshift(preferredCountry)
    }
  }

  return countries
}

export function getPopularDdiCountryList(preferredIso3 = '') {
  const normalizedIso3 = String(preferredIso3 || '').toUpperCase()
  const popular = POPULAR_PHONE_COUNTRIES.map(country => ({ ...country }))

  if (normalizedIso3) {
    const preferredIndex = popular.findIndex(
      country => String(country.iso3 || '').toUpperCase() === normalizedIso3,
    )
    if (preferredIndex > 0) {
      const [preferredCountry] = popular.splice(preferredIndex, 1)
      popular.unshift(preferredCountry)
    }
  }

  return popular
}

export function getDdiCountryList(apiCountries = [], preferredIso3 = '') {
  const popular = getPopularDdiCountryList(preferredIso3)
  const seenCodes = new Set(popular.map(country => String(country.phone_Code)))
  const additionalCountries = (apiCountries || []).filter(country => {
    const phoneCode = String(country.phone_Code || '')
    if (!phoneCode || seenCodes.has(phoneCode)) return false
    seenCodes.add(phoneCode)
    return true
  })

  return [...popular, ...additionalCountries]
}

export function findCountryByIso3(countries = [], iso3 = '') {
  const normalizedIso3 = String(iso3 || '').toUpperCase()
  if (!normalizedIso3) return null

  return (
    countries.find(country => getCountryIso3(country) === normalizedIso3) || null
  )
}

export function findCountryByPhoneCode(countries = [], phoneCode = '') {
  const normalizedCode = String(phoneCode || '').replace(/\D/g, '')
  if (!normalizedCode) return null

  return (
    countries.find(country => String(country.phone_Code || '').replace(/\D/g, '') === normalizedCode) ||
    null
  )
}

export function findCountryByPhonePrefix(countries = [], phoneDigits = '') {
  const normalizedDigits = String(phoneDigits || '').replace(/\D/g, '')
  if (!normalizedDigits || !countries.length) return null

  const sortedCountries = [...countries].sort(
    (a, b) => String(b.phone_Code || '').length - String(a.phone_Code || '').length,
  )

  return (
    sortedCountries.find(country => {
      const code = String(country.phone_Code || '').replace(/\D/g, '')
      return code && normalizedDigits.startsWith(code)
    }) || null
  )
}

export function isFrancePhoneCountry(country = null) {
  if (!country) return false

  return getCountryIso3(country) === 'FRA' || String(country.phone_Code || '').replace(/\D/g, '') === '33'
}

export function isFranceRegistration(registration = {}) {
  if (!registration || typeof registration !== 'object') return false

  if (registration.phoneCountryIsFrance === true) return true
  if (String(registration.phoneCountryIso3 || '').toUpperCase() === 'FRA') return true
  if (String(registration.phoneCountryCode || '').replace(/\D/g, '') === '33') return true

  const phoneDigits = String(registration.phone || '').replace(/\D/g, '')
  if (!phoneDigits) return false

  if (phoneDigits.startsWith('33')) return true

  const country = findCountryByPhonePrefix(getPopularDdiCountryList(), phoneDigits)
  return isFrancePhoneCountry(country)
}
